import React from 'react';
import PropTypes from 'prop-types';
import NoSSR from 'react-no-ssr';

import { Section } from '@spotahome/ui-library';

import AppBanner from '@components/AppBanner';
import Cookies from '@components/Cookies';
import SessionExpiredModal from '@components/SessionExpiredModal';
import CitiesShowcase from '@components/CitiesShowcase';
import Footer from '@components/Footer';
import GoogleOneTap from '@components/GoogleOneTap';

import FAQSection from '../../../../common/components/FAQSection';

import Hero from './Hero';
import FeatureBoxSection from './FeatureBoxSection';
import QuoteSection from './QuoteSection';
import PhoneScrollerSection from './PhoneScrollerSection';
import GuaranteeSection from './GuaranteeSection';
import CardTestimonialQuoteSection from './CardTestimonialQuoteSection';
import FindYourHome from './FindYourHome';
import HomeFooter from './HomeFooter';

const Homepage = ({ cityList, userId }) => (
  <>
    <AppBanner />
    <GoogleOneTap isUserLogged={!!userId} />
    <Hero cityList={cityList} />
    <NoSSR>
      <FeatureBoxSection />
      <QuoteSection />
      <PhoneScrollerSection />
      <GuaranteeSection />
      <Section background="light">
        <CitiesShowcase cityList={cityList} />
      </Section>
      <CardTestimonialQuoteSection />
      <FAQSection />
      <FindYourHome cityList={cityList} />
      <HomeFooter />
      <Footer />
      <SessionExpiredModal />
      <Cookies />
    </NoSSR>
  </>
);

Homepage.propTypes = {
  cityList: PropTypes.shape({}).isRequired,
  userId: PropTypes.string.isRequired
};

Homepage.NAME = 'TenantLandingName';

export default Homepage;
